import React from 'react'
import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {
  IdentityCell,
  ActionsCell,
  DateCell,
  CustomHeader
} from '@/components/table/columns'

import {BrowserCell, IpCell, ProviderCell, StatusCell} from './AuthCells'
import {IntlShape} from 'react-intl'

const df = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric'
} as Intl.DateTimeFormatOptions

const getColumns = (intl: IntlShape) : ReadonlyArray<Column<Model>> => [{
  Header: (props) => <CustomHeader tableProps={props} title={intl.formatMessage({id:'CORE.USERS.ACTIVITY.TABLE.COL_USER'})} className='min-w-125px' />,
  id: 'lastname',
  Cell: ({...props}) =>
    <IdentityCell
      email={props.data[props.row.index].user.email}
      displayName={props.data[props.row.index].user.username}
      to={`/p2c/customers/${props.data[props.row.index].user._id}/overview`}
    />
}, {
  Header: (props) => <CustomHeader tableProps={props} title={intl.formatMessage({id:'CORE.USERS.ACTIVITY.TABLE.COL_DATE'})} className='min-w-125px' />,
  id: 'date',
  Cell: ({...props}) => <DateCell date={props.data[props.row.index].date} format={df}/>
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Browser' className='min-w-125px sortable' />,
  id: 'browser',
  Cell: ({...props}) => <BrowserCell ua={props.data[props.row.index].userAgent} />
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Provider' className='min-w-25px text-center sortable' />,
  id: 'provider',
  Cell: ({...props}) => <ProviderCell provider={ props.data[props.row.index]?.provider} />
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Ip' className='min-w-125px sortable' />,
  id: 'clientIp.value',
  Cell: ({...props}) => <IpCell ip={props.data[props.row.index].clientIp} />
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Status' className='min-w-25px text-center sortable' />,
  id: 'error',
  Cell: ({...props}) => <StatusCell error={props.data[props.row.index]?.error} />
}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title={intl.formatMessage({id:'COMPONENT.TABLE.COL.ACTIONS'})} className='text-end min-w-100px' />
  ),
  id: 'actions',
  Cell: ({...props}) => (
    <ActionsCell
      itemForUpdate={props.data[props.row.index]}
      actions={[{
        icon: 'badge',
        label: intl.formatMessage({id:'CORE.USERS.ACTIVITY.TABLE.COL.ACTION.USER_VIEW'}),
        navigate:  `/p2c/customers/${props.data[props.row.index].user._id}/overview`
      }]}
    />
  )
}]

export {getColumns}
